'use client';

import Cookies from 'js-cookie';
import { usePathname } from 'next/navigation';
import { useMemo } from 'react';

import { decodeJwt, useDecisions, useUserSession } from '@libs/common-next';
import { isAccessTokenAuth0 } from '@libs/core';

import './AOSBanner.scss';

export function AOSBanner() {
    const { user } = useUserSession();
    const isAuth0EnabledForAOS = useDecisions('auth0_aos');
    const oktaAccessToken = Cookies.get('oktaAccessToken');
    const pathname = usePathname();
    const isCheckout = pathname === '/checkout';
    const experience = isAccessTokenAuth0() ? 'Auth0' : 'Janrain';

    const decodedJwt = decodeJwt(user?.oktatoken ?? oktaAccessToken);

    const userName = useMemo(() => {
        if (decodedJwt && typeof decodedJwt.payload !== 'string' && decodedJwt?.payload.sub) {
            return decodedJwt.payload.sub.split('@')[0];
        }
        return null;
    }, [decodedJwt]);

    return (
        !isCheckout &&
        (oktaAccessToken || user?.oktatoken) && (
            <div className="aos__banner">
                <span>
                    <p>CALL CENTER SESSION</p>

                    {userName && (
                        <>
                            <div />
                            <p>Client ID: {userName}</p>
                        </>
                    )}
                    {isAuth0EnabledForAOS && (
                        <>
                            <div />
                            <p>Experience: {experience}</p>
                        </>
                    )}
                </span>

                {isAuth0EnabledForAOS && (
                    <span>
                        <p>CLOSE THIS TAB BEFORE OPENING A NEW SESSION TO PREVENT EXPERIENCE COLLISION</p>
                    </span>
                )}
            </div>
        )
    );
}
